type VariantsGridLayoutProps = {
  children: React.ReactNode[];
};

export const VariantsGridLayout = ({ children }: VariantsGridLayoutProps) => {
  const count = children.length;

  if (count <= 3) {
    return (
      <div className="flex w-full flex-1 items-center justify-center gap-6">
        {children}
      </div>
    );
  }

  return (
    <div className="grid w-full flex-1 grid-cols-1 gap-6 overflow-scroll md:grid-cols-3">
      {children.map((child, i) => (
        // eslint-disable-next-line react/no-array-index-key -- key is not needed here
        <div key={i} className="flex justify-center">
          {child}
        </div>
      ))}
    </div>
  );
};
